<script setup lang="ts">
defineProps({
	isShow: {
		type: Boolean,
		default: false,
		required: true,
	},
	isJapanDiscoveryPage: {
		type: Boolean,
		default: false,
	},
});

defineEmits<{
	(e: 'onConfirm'): void;
}>();
</script>

<template>
	<ConfirmDialog
		:is-show="isShow && !isJapanDiscoveryPage"
		confirm-button-name="Ok, I got it"
		hide-cancel-button
		hide-close-icon
		@on-confirm="$emit('onConfirm')"
	>
		<template #header>
			<AlertCircleIcon
				class="icon-header-confirm-dlg icon-info"
				:color="ICON_COLOR.PRIMARY"
			/>
		</template>
		<template #title>
			Update your country setting
		</template>
		<template #content>
			<div class="content">
				<p class="text-sm text-regular">
					To view this page, please update your country setting in your account settings to the
					United States.
				</p>
			</div>
		</template>
	</ConfirmDialog>
</template>
